import { ReactComponent as Caixa } from '../../pages/assets/cuate.svg'
import './ListNotasChildrens.css'

export const Table = ({ style, arr, className }) => {

    return (
        <section style={style} className={`body-list-notas_table_content ${className}`}>
            {
                arr.length === 0 ?
                    <div className='no-data-dash-content'>
                        <div className='no-data-dash'>
                            <h1>No Data</h1>
                            <Caixa />
                        </div>
                    </div>
                    :
                    <table className="body-list-notas_table">
                        <thead>
                            <tr>
                                <th style={{ width: '20%' }}>Name</th>
                                <th style={{ width: '10%' }}>Action</th>
                                <th style={{ width: '40%' }}>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                arr.map((value, i) => (
                                    <tr key={i} >
                                        <td>
                                            <div className="body-list-notas_card_content_card_title" style={{ display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'flex-start' }}>
                                                <h1 style={{ fontSize: 14, fontWeight: 600 }}>{value.name}</h1>
                                                <h2 style={{ fontSize: 10 }}>{value.email}</h2>
                                            </div>
                                        </td>
                                        <td><div style={{ display: 'flex', alignItems: 'center', gap: 5 }}><h2 style={{ fontSize: 13, fontWeight: 400, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '30vw', maxWidth: '30vw' }}>{value.action}</h2></div></td>
                                        <td>
                                            {(() => {
                                                const date = new Date(value.createdAt);
                                                date.setHours(date.getHours() + 3);
                                                return date.toLocaleString('en-US', {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                });
                                            })()}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table >
            }
        </section >
    )
}